<template>
  <div v-if="terms" class="mb-3 justify-content-center w-100">
    <p v-html="terms" class="text-center" />
  </div>
</template>

<script>
import { fetchSlotTerms } from "../../services/FacilityService";
import { mapGetters } from "vuex";
export default {
  name: "TermsPage",
  computed: {
    ...mapGetters(["user"])
  },
  data() {
    return {
      terms: [],
      success: false,
      error: false
    };
  },
  async mounted() {
    await this.getTAndC();
  },
  methods: {
    async getTAndC() {
      let res = await fetchSlotTerms(this.$route.params.id);
      if (res && res.terms) {
        this.terms = res.terms;
        // this.$refs.TermsAndConditions.showModal();
      }
      if (res.error) {
        this.text = "An internal server error occurred. Please try later.";
      }
    }
  }
};
</script>
